import { useSearchParams } from 'react-router-dom';

export const useReferralCode = () => {
  const [searchParams] = useSearchParams();
  const searchCode = searchParams.get('code');
  const writeCodeToSessionStorage = () => {
    if (searchCode && searchCode !== sessionStorage.getItem('code')) {
      sessionStorage.setItem('code', searchCode);
    }
  };
  const code = searchCode || sessionStorage.getItem('code');
  return {
    code: code,
    isFromReferral: !!code,
    writeCodeToSessionStorage,
  };
};

export default useReferralCode;
